<script>
import { h, computed } from 'vue';
let keyActive = '';
export default {
  name: 'legoDashboard',
  render(props) {
    let slot = props.$slots.default()[0].children && props.$slots.default()[0].children.length;
    const rowLength = Math.ceil(slot / props.col) || props.row;
    const gapLength = Math.ceil(slot / props.col) - 1;
    const args = {
      style: [
        {
          height: props.vsize && `${rowLength * props.vsize + props.gap * gapLength}px`
        }
      ]
    };
    args.class = ['lego-dashboard'];
    if (this.dev) {
      args.class.push('lego-dashboard--dev');
    }
    return h('div', args, this.genItems());
  },
  data() {
    return {
      keyActive: ''
    };
  },
  provide() {
    return {
      changeDataKey: (key) => {
        this.keyActive = key;
      },
      isActive: computed(() => this.keyActive)
    };
  }
};
</script>
